module.exports = __webpack_public_path__ + "static/media/05b.4f1ec48f.png";